module.exports = __webpack_public_path__ + "img/HHaplakat2024.89a733cc.jpg";